import { clientEnv } from '../../../exports/env'

export const RETAILER_AGENT_BASE_URL = `${clientEnv.PUBLIC_CLIENT_RETAILER_PLATFORM_MESH_URL}/api/ai-chat`

const SESSION_KEY = 'session'

export function getSessionToken(): string | undefined {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (raw) {
      const parsed = JSON.parse(raw) as { token?: string }
      return parsed?.token
    }
  } catch {
    // ignore parse errors
  }
  return undefined
}
